/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */

const WorkshopsUnique = ({ sectionContent }) => {
  // console.log(sectionContent, 'workshop');
  const paragraph =
    sectionContent[0]?.body?.value?.document?.children?.[0]?.children || [];

  // Extract the specific text parts
  const firstPart = paragraph?.[0]?.value || '';
  const secondPart = paragraph?.[1]?.value || '';
  const cardsData = sectionContent[1].simpleCards;

  return (
    <Box
      width="100%"
      height="auto"
      paddingX={{ base: '10px', md: 4 }}
      pb={20}
      mt="-5rem"
      pos="relative"
      _before={{
        content: "''",
        width: '100%',
        height: '130%',
        pos: 'absolute',
        top: { base: '0%', md: '15%' },
        background: '#FEFAF6',
        backgroundBlendMode: 'multiply',
        left: '0',
        right: '0',
        bottom: '-30%',
        zIndex: '-1',
      }}
      _after={{
        content: "''",
        width: '100%',
        height: { base: '20%', md: '50%' },
        pos: 'absolute',
        top: { base: '-15%', md: '-15%' },
        background: '#FEFAF6',
        // backgroundBlendMode: 'multiply',
        left: '0',
        right: '0',
        zIndex: '-1',
        bg: 'linear-gradient(0deg, #FEFAF6 10.83%, rgba(239, 225, 196, 0.70) 57.45%, rgba(204, 169, 82, 0.00) 96.77%)',
      }}
    >
      {/* Box for heading */}

      <Box
        display="flex"
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ md: '2', base: '2' }}
        justifyContent={{ md: 'center' }}
        marginLeft={{ base: '5%', sm: '16%', md: '0' }}
        letterSpacing="1%"
        lineHeight={{ base: '1.8rem', lg: '3.9rem' }}
        fontSize={{ base: '1.5rem', md: '2.5rem', lg: '3.25rem' }} // 24px in rem
        alignItems={{ md: 'center' }}
        textAlign={{ base: 'left', md: 'center' }}
      >
        <Text
          fontFamily={'var(--FedraSerifDisplay-Regular)'}
          color="#010509"
          fontWeight="normal"
        >
          {firstPart}
        </Text>
        <Text fontFamily={'var(--FedraSerifDisplay-Bold)'}>{secondPart}</Text>
      </Box>

      {/* Box for cards */}
      <Box
        mt={{ base: '24px', md: '40px' }}
        display="flex"
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ base: 8, xl: '0', '2xl': '5rem' }}
        alignItems={{ base: 'center', md: 'stretch' }}
        justifyContent="center"
        maxW={{ base: '100%', md: '1200px', xl: '1470px' }}
        mx={{ base: 'auto', xl: '3.5rem', '2xl': 'auto' }}
      >
        {cardsData.map((card, index) => (
          <Box
            key={index}
            display="flex"
            flexDirection="column"
            alignItems="center"
            width={{ base: '100%', md: '322px', lg: '417px' }}
            maxW={{ base: '328px', lg: '417px' }}
            // this is used for layout
            // maxW={{ base: '328px', md: '322px', lg: '417px' }}
            px={{ base: '0', md: 0 }} // Center cards on small screens
          >
            {/* Box for image */}
            <Box
              objectFit="cover"
              flex="0 0 auto"
              // width="100%"
              width={{ xl: '370px', '2xl': '470px' }}
              height={{ base: 'auto', md: 'auto', xl: '422px', '2xl': '470px' }}
            >
              <LazyLoadImageComponent
                src={card.rectangularImage.url}
                alt={card.rectangularImage.alt || 'no image'}
                // width={417}
                // height={328}
                width="100%"
                height="100%"
              />
            </Box>
            {/* Box for text */}
            <Box
              //  px={".4rem"}
              mt={{ base: '16px', md: '32px' }}
              flex="1 1 auto"
              width={{ base: '100%', xl: '75%', '2xl': '98%' }}
            >
              <Text
                fontFamily="var(--FedraSansStd-medium)"
                color="#010509"
                fontWeight={500}
                textAlign="center"
                // noOfLines={3}
                fontSize={{ base: '1rem', md: '1.25rem', lg: '1.25rem' }} // 16px, 20px, and 24px in rem
                letterSpacing="2%"
                height={{ base: 'auto', md: 'auto', lg: 'auto' }} // Set a fixed height for text container
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {card.descriptionText}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
      <Box
        display={{ base: 'flex' }}
        width={{ base: '200px', lg: '400px' }}
        justifyContent={'center'}
        mt={{ base: '2rem' }}
        mx="auto"
        maxW="500px"
      >
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1721308187-workshopkolam.png`}
          alt="Workshop Kolam"
          // width={"2rem"} // Adjust width as needed
          // // height={""} // Adjust height as needed
          // layout="responsive"
          width={'100%'}
          height={'100%'}
        />
      </Box>
    </Box>
  );
};

export default WorkshopsUnique;
